import { render } from "./header-toolbar.vue?vue&type=template&id=56cbb0cb"
import script from "./header-toolbar.vue?vue&type=script&lang=js"
export * from "./header-toolbar.vue?vue&type=script&lang=js"

import "./header-toolbar.vue?vue&type=style&index=0&id=56cbb0cb&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/header-toolbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56cbb0cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56cbb0cb', __exports__)) {
    api.reload('56cbb0cb', __exports__)
  }
  
  module.hot.accept("./header-toolbar.vue?vue&type=template&id=56cbb0cb", () => {
    api.rerender('56cbb0cb', render)
  })

}


export default __exports__